import React, { FC } from "react";
import { toast } from 'react-toastify';
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useLocale } from "../../../contexts/localeContext";

type Props = {
    onRefresh?: any
}

/**
 * This component ensures the Refresh button maintains a consistent look and feel as well as 
 * behavior.
 * @param param0 
 */
const RefreshButton: FC<Props> = ({ onRefresh }) => {
    const { translate } = useLocale();

    const onRefreshClicked = () => {
        toast.success(translate.byKey(TranslationKeys.refreshInProgress));
        onRefresh(true);
    }

    return <button type="button" className="flex ml-8 px-4 bg-lime rounded-full shadow text-white text-sm items-center" id="refreshButton"
        onClick={() => onRefreshClicked()}>
        {translate.byKey(TranslationKeys.refresh)}
    </button>
}

export default RefreshButton;